import { supabase } from "./supabase";
import { todayISO } from "./dates";
import { PIPELINE_STATUSES, type Job, type JobStatus } from "./types";

export type StatusPatch = Pick<Job, "status" | "applied" | "application_date" | "state_changed_at">;

/**
 * Change a job's status, stamping the change date and recording history.
 * Moving into a pipeline status implies the job has been applied to.
 */
export async function changeJobStatus(
  userId: string,
  job: Job,
  status: JobStatus,
  date: string = todayISO(),
): Promise<{ patch: StatusPatch; error: string | null }> {
  const applied = job.applied || PIPELINE_STATUSES.includes(status);
  const patch: StatusPatch = {
    status,
    applied,
    application_date: applied && !job.application_date ? date : job.application_date,
    state_changed_at: date,
  };
  const { error } = await supabase
    .from("jh_jobs")
    .update({ ...patch, updated_at: new Date().toISOString() })
    .eq("id", job.id);
  if (error) return { patch, error: error.message };

  const { error: hErr } = await supabase.from("jh_job_state_history").insert({
    user_id: userId,
    job_id: job.id,
    from_state: job.status,
    to_state: status,
    changed_at: date,
  });
  return { patch, error: hErr ? `Status saved, but history was not recorded: ${hErr.message}` : null };
}
